import { useMutation } from '@tanstack/react-query';

import { xsollaStoreService } from 'api/xsollaStore';

export const useTopUpBalanceMutate = () =>
    useMutation({
        mutationFn: xsollaStoreService.createOrder,
    });
